import React, { useEffect } from 'react';
import { useAuth0 } from 'utils';

const RestartLogin = () => {
  const { loading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!loading) {
      loginWithRedirect();
    }
  }, [loading]);

  return <></>;
};

export default RestartLogin;
